// 文言は日英の両方を持つ。日本語が正本で、英語は同じ鍵を全部持つ（型で確かめる）。
import type { Locale } from "@appful/sdk/protocol";

const ja = {
  "meta.title": "appful games｜ブラウザですぐ遊べるゲーム",
  "meta.description": "登録なしで、ブラウザですぐ遊べるゲームを集めました。1回1〜3分の短いゲームも、続きを残して長く遊ぶゲームもあります。スマホでも PC でも遊べます。",
  "nav.home": "ホーム",
  "nav.search": "さがす",
  "nav.continue": "続きから",
  "nav.me": "マイページ",
  "search.placeholder": "ゲームをさがす",
  "lang.ja": "日本語",
  "lang.en": "EN",
  "lang.switchAria": "言語を切り替える",
  "auth.signIn": "ログイン",
  "auth.title": "ログインして、記録を残そう",
  "auth.lead": "別の端末でも、続きから遊べます。",
  "auth.google": "Google で続ける",
  "auth.private": "名前やメールアドレスは、ほかの人に見せません。",
  "auth.back": "ログインせずに戻る",
  "auth.failed": "ログインできませんでした。もう一度お試しください。",
  "auth.popupBlocked": "ログインの画面が開けませんでした。ポップアップを許可してください。",
  // ランキングに出る名前を決める窓（ui/name-dialog.ts。ログインのあとと、マイページの「名前を変える」）
  // 見出しの \u200b は、文節の切れ目（iPhone の Safari は文節で折り返さないので、ここでだけ折り返す）
  "name.title": "ランキングに出る\u200b名前を決めよう",
  "name.placeholder": "例：はやいラッコ",
  "name.checking": "確かめています…",
  "name.ok": "使えます",
  "name.taken": "この名前はもう使われています",
  "name.ng": "使えない言葉が入っています",
  "name.chars": "使える字は、ひらがな・カタカナ・漢字・英字・数字と「ー」です",
  "name.length": "{min}〜{max}文字で入れてください",
  "name.tooMany": "名前を変えられるのは1日5回までです。明日また変えてください。",
  "name.failed": "名前を決められませんでした。少し待ってから、もう一度押してください。",
  "name.notReady": "準備中です。少しあとで押し直してください。",
  "name.note": "ランキングでみんなに見えます。",
  "name.notePrivate": "本名や学校の名前は入れないでください。",
  "name.auto": "おまかせ",
  "name.save": "この名前にする",
  "name.later": "あとで決める",
  "name.cancel": "やめる",
  "name.saved": "名前を「{name}」にしました",
  "common.close": "閉じる",
  "home.continue": "続きから",
  "home.continueSub": "この端末で遊んだゲーム",
  "home.featured": "今日のおすすめ",
  "home.featuredSub": "どれも登録なしで、すぐ遊べます",
  "home.results": "見つかったゲーム",
  "home.empty": "まだゲームがありません。",
  "home.noMatch": "当てはまるゲームがありません。",
  "home.count": "{n}本",
  "home.countOne": "1本",
  "home.all": "すべてのゲーム",
  "nav.categories": "カテゴリー",
  "home.introTitle": "appful games について",
  "home.introBody": "appful games は、登録もインストールも要らず、ブラウザですぐ遊べる Web ゲームの場です。スマホでも、タブレットでも、パソコンでも遊べます。1回1〜3分の短いゲームから、ほかの人と対戦するゲームまで、appful の作り手が1本ずつ作り、遊んで確かめてから並べています。\n\nどのゲームのページにも、遊び方と、1回に遊ぶ時間の目安を書いています。名前や写真を入力する欄はありません。広告は、遊びの区切りと決まった枠にだけ出します。",
  "home.introLink": "このサイトについて、くわしく見る",
  "home.about": "appful games は、スマホのアプリを作っている appful の Web ゲームの場です。1回1〜3分の短いゲームと、続きを残して長く遊ぶゲームを足していきます。",
  "chip.all": "すべて",
  "chip.quick": "1分で遊べる",
  "saved.device": "端末に保存",
  "saved.cloud": "クラウドに保存",
  "saved.deviceDone": "端末に保存しました",
  "saved.cloudDone": "クラウドに保存しました",
  "badge.draft": "下書き",
  "badge.long": "続きから遊べる",
  "time.about": "約{n}分",
  "time.range": "{a}〜{b}分",
  "play.play": "遊ぶ",
  "play.noSignup": "登録なし",
  "play.portrait": "縦の画面",
  "play.landscape": "横の画面",
  "play.howTo": "遊び方",
  "play.tips": "コツ",
  "play.info": "このゲームについて",
  "play.saveNote": "このゲームは端末に続きを保存します。ログインすると、別の端末でも続きから遊べます。",
  "play.next": "次に遊ぶ",
  "play.back": "もどる",
  "play.fullscreen": "全画面",
  "online.stamp": "スタンプ",
  "online.players": "部屋の人",
  "online.you": "あなた",
  "online.left": "抜けました",
  "online.block": "ブロック",
  "online.blocked": "{name}さんをブロックしました。次から同じ部屋になりません",
  "online.blockNote": "ブロックした人とは、次から同じ部屋になりません。困ったことがあったら、通報してください。",
  "online.report": "通報",
  "online.reportTitle": "{name}さんを通報する",
  "online.reportReason": "理由を選んでください。",
  "online.reported": "通報を受け付けました。ありがとうございます",
  "online.back": "戻る",
  "online.stampFrom": "{name}：{stamp}",
  "online.suspendedTitle": "対戦のお休み",
  "online.suspended": "ほかの人から『こまった』という知らせがいくつか届いたので、{date}まで対戦はお休みです。ひとりで遊ぶゲームはそのまま遊べます。わからないときは、おうちの人といっしょにお問い合わせください。",
  "report.cheat": "ズルをしている",
  "report.grief": "わざと邪魔をする",
  "report.afk": "ずっと動かない",
  "report.other": "そのほか",
  "stamp.hello": "よろしく！",
  "stamp.nice": "ナイス！",
  "stamp.thanks": "ありがとう",
  "stamp.sorry": "ごめん",
  "stamp.gg": "いい勝負！",
  "stamp.again": "もう1回！",
  "stamp.wow": "すごい！",
  "stamp.go": "いくぞ！",
  "play.soundOn": "音を出す",
  "play.soundOff": "音を消す",
  "play.loading": "読み込み中…",
  "play.loadingMore": "もう少しで遊べます…",
  "play.notFound": "このゲームは見つかりません。",
  "rank.daily": "今日のランキング",
  "rank.all": "これまでのランキング",
  "rank.tab.daily": "今日",
  "rank.tab.all": "これまで",
  "rank.empty": "まだ記録がありません。",
  "rank.error": "ランキングを読めませんでした。",
  "rank.guest": "あなた（ゲスト）",
  "rank.place": "{n}位",
  "result.done": "できあがり",
  "result.points": "点",
  "result.best": "自己ベスト",
  "result.today": "今日",
  "result.allTime": "これまで",
  "result.retry": "もう一回",
  "result.nextGame": "次のゲーム",
  "result.nudge": "ログインすると、ランキングに名前が残り、別の端末でも続きから遊べます。",
  "result.signIn": "ログインする",
  "result.later": "あとで",
  "result.offline": "ランキングにつながりませんでした。点は端末に残っています。",
  "ads.label": "広告",
  "ads.banner": "広告の枠（見本）",
  "ads.sample": "広告の見本です。審査の前なので、本物の広告は出ません。",
  "ads.rewardWait": "あと {n} 秒で報酬",
  "ads.rewardReady": "報酬を受け取る",
  "ads.skip": "報酬なしで閉じる",
  "me.title": "マイページ",
  "me.guest": "ゲスト",
  "me.guestNote": "オンライン対戦のほかは、ログインしなくても遊べます。",
  "me.nameNote": "ランキングに出る名前です。",
  "me.nameNoteUnchosen": "名前をまだ決めていません。決めるまで、ランキングでは名前の後ろに番号が出ます。",
  "me.nameChange": "名前を変える",
  "me.nameChoose": "名前を決める",
  "me.saves": "続きから（セーブ）",
  "me.savesEmpty": "まだセーブがありません。",
  "me.savesGuest": "ログインすると、クラウドのセーブがここに並びます。",
  "me.records": "自分の記録",
  "me.recordsEmpty": "まだ記録がありません。",
  "me.col.game": "ゲーム",
  "me.col.best": "自己ベスト",
  "me.settings": "設定",
  "adfree.title": "広告を消す",
  "adfree.price": "月額{yen}円",
  "adfree.lead": "appful games のすべてのゲームで、広告が出なくなります。ごほうびの広告は、見なくてもごほうびがもらえます。",
  "adfree.consent": "18歳以上です。または、保護者の同意を得ています。",
  "adfree.note": "支払いは Stripe の画面で行います。カードの情報は appful には届きません。いつでも解約できます。",
  "adfree.subscribe": "申し込む",
  "adfree.signin": "申し込むには、ログインが要ります。",
  "adfree.active": "広告なしで遊べます",
  "adfree.renews": "次の更新：{date}",
  "adfree.ends": "{date}に終わります（解約済み）",
  "adfree.manage": "支払いの管理・解約",
  "adfree.thanks": "申し込みを受け付けました。広告が消えるまで、少しかかることがあります。",
  "adfree.cancelled": "申し込みをやめました。",
  "adfree.failed": "支払いの画面を開けませんでした。少しあとで、もう一度試してください。",
  "adfree.legal": "特定商取引法に基づく表示",
  "me.language": "言語",
  "me.deviceData": "この端末のデータ",
  "me.clear": "消す",
  "me.clearWarn": "この端末に保存した続きと、遊んだゲームの一覧を消します。クラウドのセーブは消えません。",
  "me.clearYes": "この端末のデータを消す",
  "me.cleared": "この端末のデータを消しました。",
  "me.account": "アカウント",
  "me.signOut": "ログアウト",
  "me.delete": "削除する",
  "me.deleteWarn": "セーブとランキングの記録も消えます。元に戻せません。",
  "me.deleteYes": "アカウントを削除する",
  "me.deleted": "アカウントを削除しました。",
  "footer.note": "登録しなくても、オンライン対戦のほかは、すべてのゲームを遊べます。自由に文字を送り合う機能はありません。",
  "footer.co": "© 2026 appful inc. All rights reserved.",
  "footer.tag": "#アプリで世界をビューティフルに",
  "footer.about": "このサイトについて",
  "footer.privacy": "プライバシーポリシー",
  "footer.tokushoho": "特定商取引法に基づく表記",
  "footer.contact": "お問い合わせ",
  "notFound.title": "ページが見つかりません",
  "notFound.back": "ホームへ",
  "error.generic": "うまくいきませんでした。時間をおいて、もう一度お試しください。",
  "genre.action": "アクション",
  "genre.puzzle": "パズル",
  "genre.mystery": "推理",
  "genre.casual": "カジュアル",
  "genre.simulation": "シミュレーション",
  "genre.strategy": "ストラテジー",
  "genre.sports": "スポーツ",
  "genre.racing": "レース",
  "genre.arcade": "アーケード",
  "genre.learning": "まなび",
  "genre.other": "そのほか",
  "subject.math": "算数",
  "subject.japanese": "国語",
  "subject.social": "社会",
  "subject.science": "理科",
  "subject.english": "英語",
  "grade.e1": "小1",
  "grade.e2": "小2",
  "grade.e3": "小3",
  "grade.e4": "小4",
  "grade.e5": "小5",
  "grade.e6": "小6",
  "grade.jh": "中学",
};

export type MessageKey = keyof typeof ja;

const en: Record<MessageKey, string> = {
  "meta.title": "appful games | Play instantly in your browser",
  "meta.description": "A collection of games you can play right in your browser, no sign-up needed. Some are quick games that take 1 to 3 minutes, and others let you save your progress and play for a long time. Play on your phone or your PC.",
  "nav.home": "Home",
  "nav.search": "Search",
  "nav.continue": "Continue",
  "nav.me": "My page",
  "search.placeholder": "Search games",
  "lang.ja": "日本語",
  "lang.en": "EN",
  "lang.switchAria": "Switch language",
  "auth.signIn": "Sign in",
  "auth.title": "Log in to save your progress",
  "auth.lead": "Pick up where you left off on any device.",
  "auth.google": "Continue with Google",
  "auth.private": "Your name and email are never shown to other people.",
  "auth.back": "Go back without signing in",
  "auth.failed": "Couldn't sign in. Please try again.",
  "auth.popupBlocked": "The sign-in window was blocked. Please allow pop-ups.",
  // 英語は翻訳 bot（npm run translate）が埋める
  "name.title": "Pick a name for the leaderboard",
  "name.placeholder": "Example: Speedy Otter",
  "name.checking": "Checking…",
  "name.ok": "This name is available",
  "name.taken": "This name is already taken",
  "name.ng": "This name has a word that can't be used",
  "name.chars": "You can use hiragana, katakana, kanji, English letters, numbers, and the long vowel mark.",
  "name.length": "Please enter {min} to {max} characters",
  "name.tooMany": "You can change your name up to 5 times a day. Please try again tomorrow.",
  "name.failed": "Couldn't set your name. Please wait a moment and try again.",
  "name.notReady": "Not ready yet. Please try again in a moment.",
  "name.note": "Everyone can see it on the leaderboard.",
  "name.notePrivate": "Please don't use your real name or your school's name.",
  "name.auto": "Surprise me",
  "name.save": "Use this name",
  "name.later": "Choose later",
  "name.cancel": "Cancel",
  "name.saved": "Your name is now \"{name}\"",
  "common.close": "Close",
  "home.continue": "Continue",
  "home.continueSub": "Games played on this device",
  "home.featured": "Today's picks",
  "home.featuredSub": "No sign-up. Play right away.",
  "home.results": "Games found",
  "home.empty": "No games yet.",
  "home.noMatch": "No games match.",
  "home.count": "{n} games",
  "home.countOne": "1 game",
  "home.all": "All Games",
  "nav.categories": "Categories",
  "home.introTitle": "About appful games",
  "home.introBody": "appful games is a place to play web games right in your browser, with no sign-up and nothing to install. You can play on a phone, tablet, or computer. From short games that take 1 to 3 minutes to games where you battle other players, each one is made by an appful creator, and we play and check it before we list it.\n\nEvery game page explains how to play and about how long one round takes. There are no fields for entering your name or a photo. Ads appear only between rounds and in set spots.",
  "home.introLink": "Learn more about this site",
  "home.about": "appful games is a place for web games from appful, the makers of mobile apps. We're adding quick games that take 1 to 3 minutes, and games you can save and keep playing.",
  "chip.all": "All",
  "chip.quick": "1-minute games",
  "saved.device": "Saved on this device",
  "saved.cloud": "Saved to cloud",
  "saved.deviceDone": "Saved on this device",
  "saved.cloudDone": "Saved to cloud",
  "badge.draft": "Draft",
  "badge.long": "Pick up where you left off",
  "time.about": "about {n} min",
  "time.range": "{a}–{b} min",
  "play.play": "Play",
  "play.noSignup": "No sign-up",
  "play.portrait": "Portrait",
  "play.landscape": "Landscape",
  "play.howTo": "How to play",
  "play.tips": "Tips",
  "play.info": "About this game",
  "play.saveNote": "This game saves your progress on this device. Sign in to continue on another device.",
  "play.next": "Play next",
  "play.back": "Back",
  "play.fullscreen": "Fullscreen",
  "online.stamp": "Stamps",
  "online.players": "Players in the room",
  "online.you": "You",
  "online.left": "Left",
  "online.block": "Block",
  "online.blocked": "You blocked {name}. You won't be in the same room again.",
  "online.blockNote": "You won't be in the same room as people you block. If something's wrong, please report it.",
  "online.report": "Report",
  "online.reportTitle": "Report {name}",
  "online.reportReason": "Choose a reason.",
  "online.reported": "Report received. Thank you.",
  "online.stampFrom": "{name}: {stamp}",
  "online.back": "Back",
  "online.suspendedTitle": "Online Play Break",
  "online.suspended": "We got a few reports from other players, so online play is paused until {date}. Solo games are still available. If you're not sure what to do, please contact us together with a parent or guardian.",
  "report.cheat": "Cheating",
  "report.grief": "Getting in the way on purpose",
  "report.afk": "Not moving for a long time",
  "report.other": "Other",
  "stamp.hello": "Hello!",
  "stamp.nice": "Nice!",
  "stamp.thanks": "Thanks",
  "stamp.sorry": "Sorry",
  "stamp.gg": "Good game!",
  "stamp.again": "One more!",
  "stamp.wow": "Wow!",
  "stamp.go": "Here I come!",
  "play.soundOn": "Turn sound on",
  "play.soundOff": "Turn sound off",
  "play.loading": "Loading…",
  "play.loadingMore": "Almost ready to play...",
  "play.notFound": "This game wasn't found.",
  "rank.daily": "Today's ranking",
  "rank.all": "All-time ranking",
  "rank.tab.daily": "Today",
  "rank.tab.all": "All time",
  "rank.empty": "No records yet.",
  "rank.error": "Couldn't load the ranking.",
  "rank.guest": "You (guest)",
  "rank.place": "#{n}",
  "result.done": "Finished",
  "result.points": "pts",
  "result.best": "New best",
  "result.today": "Today",
  "result.allTime": "All time",
  "result.retry": "Play again",
  "result.nextGame": "Next game",
  "result.nudge": "Log in to keep your name on the leaderboard and pick up where you left off on other devices.",
  "result.signIn": "Sign in",
  "result.later": "Later",
  "result.offline": "Couldn't reach the ranking. Your score is kept on this device.",
  "ads.label": "Ad",
  "ads.banner": "Ad space (sample)",
  "ads.sample": "This is a sample ad. Real ads will appear after review.",
  "ads.rewardWait": "Reward in {n}s",
  "ads.rewardReady": "Claim reward",
  "ads.skip": "Close without reward",
  "me.title": "My page",
  "me.guest": "Guest",
  "me.guestNote": "You can play without logging in, except for online matches.",
  "me.nameNote": "This is the name shown on the leaderboard.",
  "me.nameNoteUnchosen": "You haven't picked a name yet. Until you do, a number will appear after your name on the leaderboard.",
  "me.nameChange": "Change name",
  "me.nameChoose": "Choose a name",
  "me.saves": "Continue (saves)",
  "me.savesEmpty": "No saves yet.",
  "me.savesGuest": "Sign in to see your cloud saves here.",
  "me.records": "Your records",
  "me.recordsEmpty": "No records yet.",
  "me.col.game": "Game",
  "me.col.best": "Best",
  "me.settings": "Settings",
  "adfree.title": "Remove ads",
  "adfree.price": "{yen} yen/month",
  "adfree.lead": "No more ads in any appful games game. You'll still get your reward from reward ads without watching them.",
  "adfree.consent": "I'm 18 or older, or I have a parent or guardian's permission.",
  "adfree.note": "You'll pay on a Stripe page. appful never sees your card details. You can cancel anytime.",
  "adfree.subscribe": "Subscribe",
  "adfree.signin": "You need to log in to subscribe.",
  "adfree.active": "You're playing ad-free",
  "adfree.renews": "Renews on {date}",
  "adfree.ends": "Ends on {date} (canceled)",
  "adfree.manage": "Manage payment / Cancel",
  "adfree.thanks": "We got your subscription. It may take a little while for ads to go away.",
  "adfree.cancelled": "Subscription canceled.",
  "adfree.failed": "Couldn't open the payment page. Please try again in a little while.",
  "adfree.legal": "Notation Based on the Specified Commercial Transactions Act",
  "me.language": "Language",
  "me.deviceData": "Data on this device",
  "me.clear": "Clear",
  "me.clearWarn": "This clears progress and the played list saved on this device. Cloud saves are kept.",
  "me.clearYes": "Clear data on this device",
  "me.cleared": "Cleared the data on this device.",
  "me.account": "Account",
  "me.signOut": "Sign out",
  "me.delete": "Delete",
  "me.deleteWarn": "Your saves and ranking records will be deleted too. This can't be undone.",
  "me.deleteYes": "Delete account",
  "me.deleted": "Your account has been deleted.",
  "footer.note": "You can play every game without signing up, except online matches. There is no way to send free-form text to other players.",
  "footer.co": "© 2026 appful inc. All rights reserved.",
  "footer.tag": "#Make the world beautiful with apps",
  "footer.about": "About This Site",
  "footer.privacy": "Privacy Policy",
  "footer.tokushoho": "Notice Based on the Specified Commercial Transactions Act",
  "footer.contact": "Contact Us",
  "notFound.title": "Page not found",
  "notFound.back": "Home",
  "error.generic": "Something went wrong. Please try again later.",
  "genre.action": "Action",
  "genre.puzzle": "Puzzle",
  "genre.mystery": "Mystery",
  "genre.casual": "Casual",
  "genre.simulation": "Simulation",
  "genre.strategy": "Strategy",
  "genre.sports": "Sports",
  "genre.racing": "Racing",
  "genre.arcade": "Arcade",
  "genre.learning": "Learning",
  "genre.other": "Other",
  "subject.math": "Math",
  "subject.japanese": "Japanese",
  "subject.social": "Social studies",
  "subject.science": "Science",
  "subject.english": "English",
  "grade.e1": "Grade 1",
  "grade.e2": "Grade 2",
  "grade.e3": "Grade 3",
  "grade.e4": "Grade 4",
  "grade.e5": "Grade 5",
  "grade.e6": "Grade 6",
  "grade.jh": "Junior high",
};

const dict: Record<Locale, Record<MessageKey, string>> = { ja, en };

let current: Locale = "ja";
const listeners = new Set<(l: Locale) => void>();

export function getLocale(): Locale {
  return current;
}

export function setLocale(l: Locale) {
  if (l === current) return;
  current = l;
  document.documentElement.lang = l;
  listeners.forEach((fn) => fn(l));
}

export function onLocaleChange(fn: (l: Locale) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function t(key: MessageKey, vars: Record<string, string | number> = {}): string {
  return dict[current][key].replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? ""));
}

/** 英語の文言（見出しの丸い英字は、日本語の画面でも英語で出す。LP の ABOUT と同じ） */
export function tEn(key: MessageKey): string {
  return en[key];
}

/** 言語ごとの文言（ゲームの題名など）から今の言語の物を選ぶ */
export function pick(v: Record<Locale, string>): string {
  return v[current] ?? v.ja;
}

/** URL の先頭の /en で言語を決める。日本語は前置きなし。 */
export function localeFromPath(path: string): { locale: Locale; rest: string } {
  if (path === "/en" || path.startsWith("/en/")) return { locale: "en", rest: path.slice(3) || "/" };
  return { locale: "ja", rest: path };
}

export function localePath(path: string, l: Locale = current): string {
  return l === "en" ? `/en${path}` : path;
}
